// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

const OutboundMessage = React.forwardRef(({ type, createdAt, body, status, selected, isSMS, onClick, className, style }, ref) => {
  let styleWithPointer = { ...style, ...{ cursor: 'pointer' } }

  if (type === 'TEXT' || isSMS) {
    if (status === 'UNDELIVERABLE') {
      return (
        <li
          className={`chat-listitem chat-listitem_outbound${selected ? ' item-selected' : ''} ${className}`}
          onClick={onClick}
          style={styleWithPointer}
          ref={ref}>
          <div className='chat-message'>
            <div className='chat-message__body'>
              <div className='chat-message__text chat-message__text_delivery-failure'>
                <div className='chat-message__text_delivery-failure-reason' role='alert'>
                  <span className='slds-icon_container slds-icon-utility-error chat-icon'>
                    <svg className='slds-icon slds-icon_x-small slds-icon-text-default slds-icon-text-default' aria-hidden='true'>
                      <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#error'></use>
                    </svg>
                  </span>
                  <span>Message undeliverable.</span>
                </div>
              </div>
              <div className='slds-grid slds-grid_align-spread slds-grid_vertical-align-start'>
                <button className='slds-button chat-message__action slds-m-top_xxx-small'>
                  <span className='slds-icon_container slds-icon-utility-redo chat-icon'>
                    <svg className='slds-icon slds-icon_xx-small' aria-hidden='true'>
                      <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#redo'></use>
                    </svg>
                  </span>
                  <span>Resend</span>
                </button>
              </div>
            </div>
          </div>
        </li>
      )
    } else if (status === 'UNSENT') {
      return (
        <li
          className={`chat-listitem chat-listitem_outbound${selected ? ' item-selected' : ''} ${className}`}
          onClick={onClick}
          style={styleWithPointer}
          ref={ref}>
          <div className='chat-message'>
            <div className='chat-message__body'>
              <div className='chat-message__text chat-message__text_unsupported-type' style={{ backgroundColor: 'lightblue' }}>
                <span className='slds-icon_container slds-icon-utility-warning chat-icon' title='Warning'>
                  <svg className='slds-icon slds-icon_x-small slds-icon-text-default slds-icon-text-warning' aria-hidden='true'>
                    <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#warning'></use>
                  </svg>
                </span>
                <span>Message unsent</span>
              </div>
            </div>
          </div>
        </li>
      )
    } else {
      return (
        <li
          className={`chat-listitem chat-listitem_outbound${selected ? ' item-selected' : ''} ${className}`}
          onClick={onClick}
          style={styleWithPointer}
          ref={ref}>
          <div className='chat-message'>
            <div className='chat-message__body'>
              <div className='chat-message__text chat-message__text_outbound'>
                <span>
                  {body}
                </span>
              </div>
              <div className='chat-message__meta slds-text-align_right'>
                {moment(createdAt).format('DD MMM YYYY HH:mm:ss')}
              </div>
            </div>
          </div>
        </li>
      )
    }
  } else if (type === 'IMAGE') {
    return (
      // <section role='log' className={`chat${selected ? ' item-selected' : ''}`} onClick={onClick} style={style}>
      //   <ul className='chat-list'>
      //     <li
        // className='chat-listitem chat-listitem_outbound'>
      //       <div className='chat-message'>
      //         <div className='chat-message__body'>
      //           <div className='chat-message__text chat-message__text_outbound'>
      //             <span>
      //               <span className='slds-icon_container slds-icon-doctype-attachment chat-icon' title='Attachment'>
      //                 <svg className='slds-icon slds-icon_small' aria-hidden='true'>
      //                   <use xlinkHref='/assets/icons/doctype-sprite/svg/symbols.svg#attachment'></use>
      //                 </svg>
      //                 <span className='slds-assistive-text'>Attachment</span>
      //               </span>
      //               <a href='javascript:void(0)'>filename_of_attachment.jpg</a>
      //             </span>
      //           </div>
      //           <div className='chat-message__meta'>
      //             {moment(createdAt).format('DD MMM YYYY HH:mm:ss')}
      //           </div>
      //         </div>
      //       </div>
      //     </li>
      //   </ul>
      // </section>
      <li
        className={`chat-listitem chat-listitem_outbound${selected ? ' item-selected' : ''} ${className}`}
        onClick={onClick}
        style={styleWithPointer}
        ref={ref}>
        <div className='chat-message'>
          <div className='chat-message__body'>
            <div className='chat-message__image chat-message__image_outbound'>
              <div className='slds-file'>
                <figure>
                  {/* eslint-disable jsx-a11y/href-no-hash */}
                  <a href='#' className='slds-file__figure'>
                    <span className='slds-assistive-text'>Preview:</span>
                    <img src='/assets/images/placeholder-img@16x9.jpg' alt='placeholder' />
                  </a>
                  {/* eslint-enable jsx-a11y/href-no-hash */}
                </figure>
                <div className='slds-file__title slds-file__title_scrim'>
                  <div className='slds-file__actions-menu'>
                    <div className='slds-button-group' role='group'>
                      <button className='slds-button slds-button_icon slds-button_icon slds-button_icon-x-small slds-button_icon-inverse' title='Download'>
                        <svg className='slds-button__icon' aria-hidden='true'>
                          <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#download'></use>
                        </svg>
                        <span className='slds-assistive-text'>Download</span>
                      </button>
                      <button className='slds-button slds-button_icon slds-button_icon slds-button_icon-x-small slds-button_icon-inverse' aria-haspopup='true' title='More Actions'>
                        <svg className='slds-button__icon' aria-hidden='true'>
                          <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#down'></use>
                        </svg>
                        <span className='slds-assistive-text'>More Actions</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='chat-message__meta slds-text-align_right' aria-label='said Taylor Watson-Rice at 4:59 PM'>
              {moment(createdAt).format('DD MMM YYYY HH:mm:ss')}
            </div>
          </div>
        </div>
      </li>
    )
  } else if (type === 'FILE' || type === 'DOCUMENT') {
    return (
      <li
        className={`chat-listitem chat-listitem_outbound${selected ? ' item-selected' : ''} ${className}`}
        onClick={onClick}
        style={styleWithPointer}
        ref={ref}>
        <div className='chat-message'>
          <div className='chat-message__body'>
            <div className='chat-message__file chat-message__file_outbound'>
              <div className='slds-file slds-has-title'>
                <figure>
                  {/* eslint-disable jsx-a11y/href-no-hash */}
                  <a href='#' className='slds-file__crop slds-file__crop_4-by-3'>
                    <span className='slds-assistive-text'>Preview:</span>
                    <img src='/assets/images/placeholder-img@16x9.jpg' alt='placeholder' />
                  </a>
                  {/* eslint-enable jsx-a11y/href-no-hash */}
                  <figcaption className='slds-file__title slds-file__title_card slds-file-has-actions'>
                    <div className='slds-media slds-media_small slds-media_center'>
                      <div className='slds-media__figure slds-line-height_reset'>
                        <span className='slds-icon_container' title='pdf'>
                          <svg className='slds-icon slds-icon_x-small' aria-hidden='true'>
                            <use xlinkHref='/assets/icons/doctype-sprite/svg/symbols.svg#pdf'></use>
                          </svg>
                          <span className='slds-assistive-text'>pdf</span>
                        </span>
                      </div>
                      <div className='slds-media__body'>
                        <span className='slds-file__text slds-truncate' title='File.pdf'>File.pdf</span>
                      </div>
                    </div>
                  </figcaption>
                </figure>
                <div className='slds-file__actions-menu'>
                  <div className='slds-button-group' role='group'>
                    <button className='slds-button slds-button_icon slds-button_icon slds-button_icon-x-small' title='Download'>
                      <svg className='slds-button__icon' aria-hidden='true'>
                        <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#download'></use>
                      </svg>
                      <span className='slds-assistive-text'>Download</span>
                    </button>
                    <button className='slds-button slds-button_icon slds-button_icon slds-button_icon-x-small' aria-haspopup='true' title='More Actions'>
                      <svg className='slds-button__icon' aria-hidden='true'>
                        <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#down'></use>
                      </svg>
                      <span className='slds-assistive-text'>More Actions</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className='chat-message__meta slds-text-align_right'>
              {moment(createdAt).format('DD MMM YYYY HH:mm:ss')}
            </div>
          </div>
        </div>
      </li>
    )
  } else {
    return null
  }
})

OutboundMessage.propTypes = {
  type: PropTypes.oneOf(['TEXT', 'FILE', 'AUDIO', 'DOCUMENT', 'IMAGE', 'HSM']).isRequired,
  createdAt: PropTypes.string.isRequired,
  body: PropTypes.string,
  status: PropTypes.oneOf([
    'UNSENT',
    'SENT_UPSTREAM',
    'QUEUED',
    'RECEIVED',
    'RECEIVED_PARSED',
    'RECEIVED_PROCESSED',
    'UNDELIVERABLE',
    'DUPLICATE'
  ]).isRequired,
  className: PropTypes.string
}

OutboundMessage.defaultProps = {
  className: ''
}

export default OutboundMessage



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-related-messages-list/OutboundMessage.js